module.exports = __webpack_public_path__ + "static/ux-a666bef860892d2ae6f6380fa8d530d5.svg";